import React, { useMemo } from "react";
import { View } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { Modal } from "@lookiero/sty-psp-ui";
import { DOMAIN, I18nMessages, PREFIX } from "../../../i18n/i18n";
import { style as howToModalStyle } from "./HowToModal.style";
const HowToModal = ({ visible, portalHostName, onDismiss }) => {
    const titleText = useI18nMessage({ domain: DOMAIN, id: I18nMessages.HOW_TO_TITLE, prefix: PREFIX });
    const descriptionText = useI18nMessage({ domain: DOMAIN, id: I18nMessages.HOW_TO_PARAGRAPH_1, prefix: PREFIX });
    const otherDescriptionText = useI18nMessage({ domain: DOMAIN, id: I18nMessages.HOW_TO_PARAGRAPH_2, prefix: PREFIX });
    const style = useMemo(() => howToModalStyle(), []);
    return (React.createElement(Modal, { portalHostName: portalHostName, visible: visible, showCloseButton: true, onClose: onDismiss },
        React.createElement(View, { style: style.modal },
            React.createElement(Text, { level: 3, variant: "heading" }, titleText),
            React.createElement(View, { style: style.modalGap },
                React.createElement(Text, { style: [style.text, style.descriptionText] }, descriptionText),
                React.createElement(Text, { style: style.text }, otherDescriptionText)))));
};
export { HowToModal };
